"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayNumber = void 0;
var getDisplayNumber = function (itemNumber, indentLevel) {
    var numberType = (indentLevel - 1) % 3;
    switch (numberType) {
        case 0:
            return "".concat(itemNumber, ".");
        case 1:
            return "".concat(getLatinNumber(itemNumber), ".");
        case 2:
            return "".concat(getRomanNumber(itemNumber), ".");
        default:
            return "";
    }
};
exports.getDisplayNumber = getDisplayNumber;
var getLatinNumber = function (itemNumber) {
    var result = "";
    var currValue = itemNumber;
    while (currValue >= 1) {
        var digit = (currValue - 1) % 26;
        currValue = Math.floor((currValue - 1) / 26);
        result = String.fromCharCode(digit + 97) + result;
    }
    return result;
};
var getRomanNumber = function (itemNumber) {
    var initialResult = getRawRomanConversion(itemNumber);
    return addRomanShorthands(initialResult);
};
var getRawRomanConversion = function (itemNumber) {
    var currVal = itemNumber;
    var result = "";
    while (currVal >= 1) {
        if (currVal > 1000) {
            result += "m";
            currVal -= 1000;
        }
        else if (currVal >= 500) {
            result += "d";
            currVal -= 500;
        }
        else if (currVal >= 100) {
            result += "c";
            currVal -= 100;
        }
        else if (currVal >= 50) {
            result += "l";
            currVal -= 50;
        }
        else if (currVal >= 10) {
            result += "x";
            currVal -= 10;
        }
        else if (currVal >= 5) {
            result += "v";
            currVal -= 5;
        }
        else {
            result += "i";
            currVal -= 1;
        }
    }
    return result;
};
var addRomanShorthands = function (romanNumber) {
    return romanNumber
        .replace("dcccc", "cm")
        .replace("cccc", "cd")
        .replace("lxxxx", "xc")
        .replace("xxxx", "xl")
        .replace("viiii", "ix")
        .replace("iiii", "iv");
};
